import { render, staticRenderFns } from "./ToolText.vue?vue&type=template&id=0b4d6ac6&scoped=true"
import script from "./ToolText.vue?vue&type=script&lang=js"
export * from "./ToolText.vue?vue&type=script&lang=js"
import style0 from "./ToolText.vue?vue&type=style&index=0&id=0b4d6ac6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4d6ac6",
  null
  
)

export default component.exports